const filterFields = ["fullname", "plates", "dni", "email"];

function normalizeSearch(value) {
  return String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();
}

export function filterDriversUseCase(drivers, field, term) {
  const search = normalizeSearch(term);
  if (!search || !filterFields.includes(field)) return drivers;

  return drivers.filter((driver) =>
    normalizeSearch(driver[field]).includes(search),
  );
}
